import { render, staticRenderFns } from "./Rent.vue?vue&type=template&id=0708fcd5&scoped=true"
import script from "./Rent.vue?vue&type=script&lang=js"
export * from "./Rent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0708fcd5",
  null
  
)

export default component.exports